var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swipers nark"},[_c('div',{staticClass:"swiper mySwiper lqs"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.banner),function(item){return _c('div',{key:item.id,staticClass:"swiper-slide"},[_c('img',{staticClass:"banone",attrs:{"src":require("./img/banner-1.jpg")}})])}),0),_c('div',{staticClass:"swiper-pagination"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }